var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskReviewed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.16667H9.33333V0.583333C9.33333 0.233333 9.1 0 8.75 0H4.08333C3.73333 0 3.5 0.233333 3.5 0.583333V1.16667H0.583333C0.233333 1.16667 0 1.4 0 1.75V16.9167C0 17.2667 0.233333 17.5 0.583333 17.5H12.25C12.6 17.5 12.8333 17.2667 12.8333 16.9167V1.75C12.8333 1.4 12.6 1.16667 12.25 1.16667ZM4.66667 1.16667H8.16667V2.33333H4.66667V1.16667Z",
    fill: "#43B02A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50834 7.5442C9.74168 7.31087 10.0917 7.31087 10.325 7.5442C10.5583 7.77753 10.5583 8.12753 10.325 8.36087L5.65834 13.0275C5.54168 13.1442 5.42501 13.2025 5.25001 13.2025C5.07501 13.2025 4.95834 13.1442 4.84168 13.0275L2.50834 10.6942C2.27501 10.4609 2.27501 10.1109 2.50834 9.87753C2.74168 9.6442 3.09168 9.6442 3.32501 9.87753L5.25001 11.8025L9.50834 7.5442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskReviewed);
export default __webpack_public_path__ + "static/media/task-reviewed.ddf8acfec6befdc9e2db087c71608fa4.svg";
export { ForwardRef as ReactComponent };